export default "__VITE_ASSET__Dfi5Nlrs__"